import { creditCardAdd } from 'store/checkout/checkoutActions';
import { createCreditCardAddEvent } from '../eventCreators';
import { createCreditCardAddEventPayload } from '../dataHelpers/createCreditCardAddEventPayload';

const emitCreditCardAddEvent = ({ payload }) => {
  return createCreditCardAddEvent(
    createCreditCardAddEventPayload({
      itemName: payload.itemName,
      itemType: payload.itemType,
      provider: payload.provider,
      paymentType: payload.paymentType,
      savedCard: payload.savedCard,
      url: payload.url,
    }),
  );
};

// eslint-disable-next-line
// @ts-ignore
export default { [creditCardAdd]: emitCreditCardAddEvent };
